import { defineComponent as _defineComponent } from 'vue'
import { WccAlertNotification } from '@/models/wccAlertNotification';
import { notificationsService } from '@/services/notifications.service';
import { UserCustomNotificationStatus } from '@/models/customNotifications';
import { AlertWorkflowNotification } from '@/models/AlertWorkflowNotification';
import { isEmpty } from '@/utils/misc';
import NotificationCard from '@/components/header/NotificationCard.vue';
import { useEServiceCenterRouter } from '@/library-services/e-service-center-router';
import { useSpinner } from '@/composables/misc';
import { computed } from 'vue';
import { Notification } from '@/store/persistent/index';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'NotificationsMenu',
  setup(__props) {

const spinner = useSpinner();
const eServiceCenterRouter = useEServiceCenterRouter();
const { t } = useI18n();

async function onNotificationClicked(notification: Notification) {
  if (notification instanceof AlertWorkflowNotification) {
    await eServiceCenterRouter.goToInboxFilteredByEquipment(
      notification.customerName,
      notification.deviceName,
    );
  } else {
    dismissNotification(notification);
  }
}

function dismissNotification(
  notificationStatus: WccAlertNotification | UserCustomNotificationStatus,
) {
  spinner.showSpinner();
  const isCustomNotification =
    notificationStatus instanceof UserCustomNotificationStatus;
  notificationsService
    .dismiss(notificationStatus.id, isCustomNotification)
    .then(() => refreshNotifications())
    .finally(() => spinner.removeSpinner());
}

function dismissAllNotifications() {
  spinner.showSpinner();

  notificationsService
    .dismissAll()
    .then(() => refreshNotifications())
    .finally(() => spinner.removeSpinner());
}

async function refreshNotifications() {
  spinner.showSpinner();
  await notificationsService.get().finally(() => spinner.removeSpinner());
}

const notifications = computed(
  (): Array<Notification> => notificationsService.store.getAll(),
);

return { __sfc: true,spinner, eServiceCenterRouter, t, onNotificationClicked, dismissNotification, dismissAllNotifications, refreshNotifications, notifications, isEmpty, NotificationCard }
}

})